
















import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import axios from 'axios'

@Component({
  name: 'channel-detail-script'
})
export default class ChannelScriptTemp extends Vue {
  isLoaded = false
  script: string = ""
  saveDisabled = false
  saveText = ""
  token = ""

  mounted () {
    const channel = this.$route.params.channel
    let alerted = false
    axios.get(`/api/script/${channel}`).then((response) => {
      this.script = response.data
      console.log(this.script)
      this.isLoaded = true
    }).catch((err) => {
        if (!alerted) {
          alerted = true
          alert('not authorized, please log in via twitch')
        }
    })

    axios.get(`/api/token`).then((response) => {
      console.log(response)
      this.token = response.data.token
    }).catch((err) => {
        if (!alerted) {
          alerted = true
          alert('not authorized, please log in via twitch')
        }
    })
  }

  save() {
      const channel = this.$route.params.channel.toLowerCase()

      console.log(this.script)
      this.saveDisabled = true
      axios.post(`/api/script/${channel}`, this.script, {
          headers: {
              'Content-Type': 'text/plain',
          },
      }).then((response) => {
          console.log(response)
          this.saveText = 'Saved'
      }).catch((err) => {
        alert('not authorized, please log in via twitch')
    })
    setTimeout(() => {
        this.saveDisabled = false
        this.saveText = ''
    }, 2000)
  }
}
